import tw, { styled } from 'twin.macro';

export const NotFoundWrapper = styled.main`
  a.logo {
    ${tw`absolute`};
    line-height: 0;
    width: 135px;
    left: 40px;
    top: 31px;
    
    img {
      ${tw`w-full`};
    }
  }
  
  section {
    ${tw`flex flex-col items-center justify-evenly my-0 mx-auto`};
    padding: 120px 20px 20px 20px;
    height: 100vh;
    width: 85%;
    gap: 24px;

    .top {
      ${tw`flex flex-col items-center justify-center`};
      gap: 24px;

      a {
        background: linear-gradient(270deg, #1A8CAF -18.55%, #00AFC4 60.48%);
        padding: 10px 20px 10px 20px;
        font-family: Circular Std;
        text-align: center;
        border-radius: 3px;
        line-height: 18px;
        color: #ffffff;
        font-weight: 500;
        font-size: 14px;
      }
    }

    img {
      margin-bottom: 24px;
      width: 450px;
      height: 100%;
    }
    
    .bottom {
      border-top: 1px solid #c4c4c480;
      text-align: center;
      padding-top: 40px;
      width: 100%;
      
      a {
        border-bottom: 1px solid #007996;
        font-family: Circular Std;
        text-decoration: none;
        padding-bottom: 1px;
        text-align: center;
        line-height: 20px;
        color: #007996;
        font-weight: 400;
        font-size: 16px;
      }
    }

    p {
      font-family: Circular Std;
      text-align: center;
      line-height: 25px;
      font-weight: 400;
      font-size: 20px;
      margin: 0;
    }
  }
  
  @media (max-width: 768px) {
    section {
      width: 95%;

      img {
        width: 450px;
      }

      .bottom {
        padding-top: 20px;
      }
    }

    a.logo {
      left: 31px;
    }
  }
  
  @media (max-width: 575.8px) {
    section {
      padding-top: 80px;

      img {
        width: 300px;
      }
    }

    a.logo {
      width: 103px;
      left: 14px;
      top: 14px;
    }
  }
`;